import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from 'ck-ui';

const LinkSerializer = ({ mark: { href, type, blank }, children }) => {
  const externalLink = blank ? { target: '_blank', rel: 'noopener noreferrer' } : {};

  if (!type) {
    return (
      <Typography
        renderAs="a"
        color="white"
        underline
        href={href}
        {...externalLink}
      >
        {children}
      </Typography>
    );
  }

  if (type !== 'link') {
    return (
      <Button
        size={type}
        renderAs="a"
        {...externalLink}
        href={href}
      >
        {children}
      </Button>
    );
  }
  return (<a href={href} {...externalLink}>{children}</a>);
};

LinkSerializer.propTypes = {
  mark: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export { LinkSerializer };
